
import React from 'react';
import { useSelector } from 'react-redux';
import { StoreBase } from '../store/store';
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from '../views/Login';
import LayoutBase from '../views/Layout';

const Layout: React.FC = () => {

    const user = useSelector((state: StoreBase) => state.user);
    // 判断是否登录

    return (
        <ConfigProvider locale={zhCN}>
            {user.token ? <BrowserRouter><LayoutBase /></BrowserRouter> : <Login />}
        </ConfigProvider>
    );
};

export default Layout;